import { DesofyTheme } from "../types";

export const globals = {
    exchangeRate: { SatoshisPerDeSoExchangeRate: 0, USDCentsPerDeSoExchangeRate: 0 },
    isDarkMode: false,
    theme: DesofyTheme.Light
}